/// <reference lib="dom" />
export {}; // module scope

const form = document.querySelector<HTMLFormElement>("form[data-island='search']");
if (form) {
  const input = form.querySelector<HTMLInputElement>("input[name='q']");
  if (input) {
    const dropdown = document.createElement("ul");
    dropdown.className =
      "absolute left-0 right-0 top-full z-30 mt-1 max-h-[60vh] overflow-auto rounded-md border border-slate-200 bg-white text-sm shadow-lg";
    dropdown.hidden = true;
    form.appendChild(dropdown);

    let active = -1;
    let lastQuery = "";
    let abort: AbortController | null = null;
    let timer: number | undefined;

    const close = () => {
      dropdown.hidden = true;
      active = -1;
    };

    const renderHits = (hits: { href: string; label: string; sublabel: string; type: string }[]) => {
      dropdown.innerHTML = "";
      if (hits.length === 0) {
        const li = document.createElement("li");
        li.className = "px-3 py-2 text-slate-500";
        li.textContent = "—";
        dropdown.appendChild(li);
      } else {
        for (const h of hits) {
          const li = document.createElement("li");
          li.className = "border-t border-slate-100 first:border-t-0";
          const a = document.createElement("a");
          a.href = h.href;
          a.className = "block px-3 py-2 text-slate-700 hover:bg-brand-50 hover:no-underline";
          a.innerHTML = `<strong class="text-slate-900">${escapeHtml(h.label)}</strong><span class="ml-2 text-xs text-slate-500">${escapeHtml(h.sublabel)} · ${escapeHtml(h.type)}</span>`;
          li.appendChild(a);
          dropdown.appendChild(li);
        }
      }
      dropdown.hidden = false;
    };

    const MIN_QUERY_LEN = 3;
    const fetchHits = async (q: string) => {
      if (q.length < MIN_QUERY_LEN) {
        close();
        lastQuery = "";
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;
      abort?.abort();
      abort = new AbortController();
      try {
        const r = await fetch(`/api/search?q=${encodeURIComponent(q)}`, { signal: abort.signal });
        if (!r.ok) return;
        const hits = (await r.json()) as { href: string; label: string; sublabel: string; type: string }[];
        renderHits(hits);
      } catch {
        // ignore aborts
      }
    };

    input.addEventListener("input", () => {
      window.clearTimeout(timer);
      const q = input.value.trim();
      timer = window.setTimeout(() => fetchHits(q), 200);
    });

    input.addEventListener("keydown", (e) => {
      const items = dropdown.querySelectorAll<HTMLLIElement>("li");
      if (e.key === "ArrowDown") {
        e.preventDefault();
        active = Math.min(items.length - 1, active + 1);
        highlight(items);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        active = Math.max(-1, active - 1);
        highlight(items);
      } else if (e.key === "Enter" && active >= 0) {
        const a = items[active]?.querySelector("a");
        if (a) {
          e.preventDefault();
          window.location.href = a.href;
        }
      } else if (e.key === "Escape") {
        close();
      }
    });

    const highlight = (items: NodeListOf<HTMLLIElement>) => {
      items.forEach((el, i) => el.classList.toggle("bg-brand-50", i === active));
    };

    document.addEventListener("click", (e) => {
      if (!form.contains(e.target as Node)) close();
    });
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));
}
